import React from "react";
import PropTypes from "prop-types";
import { CommandBarButton, IconButton } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";

const ActionPlanTipTable = ({
    tips,
    setSelectedTipId,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    createDisabled
}) => {
    const columns = [
        {
            key: "column1",
            name: "ID",
            fieldName: "crsActionPlanTipID",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
        },
        {
            key: "column2",
            name: "Order",
            fieldName: "orderNumber",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true
        },
        {
            key: "column3",
            name: "Header",
            fieldName: "header",
            minWidth: 200,
            maxWidth: 400,
            isResizable: true
        },
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    item={item}
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                />
            )
        },
        {
            key: "column4",
            name: "Paragraph",
            fieldName: "paragraph",
            minWidth: 300,
            maxWidth: 500,
            isResizable: true
        },
        {
            key: "column5",
            name: "On Off Rule",
            fieldName: "onOffRule",
            minWidth: 150,
            maxWidth: 200,
            isResizable: true
        },
        {
            key: "column6",
            name: "On Off Default",
            fieldName: "onOffDefault",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
        }
    ];

    const items = tips ?? [];

    const selectionHook = (items) => {
        setSelectedTipId(items && items[0] && items[0].crsActionPlanTipID);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={"sentence"}
            style={{
                position: "relative",
                height: "80vh",
                width: "80vw",
            }}
            CommandBar={
                <CommandBarButton
                    iconProps={{ iconName: "Add" }}
                    text="Create"
                    onClick={() => createOnClick()}
                    disabled={createDisabled}
                />
            }
        />
    );
};

const moreIcon = { iconName: "More" };


// ContextualMenu moved out of parent, receives item as prop
const ContextualMenu = ({ item, editOnClick, deleteOnClick, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(item),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(item),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

ContextualMenu.propTypes = {
    item: PropTypes.object.isRequired,
    editOnClick: PropTypes.func.isRequired,
    deleteOnClick: PropTypes.func.isRequired
};


ActionPlanTipTable.propTypes = {
    tips: PropTypes.arrayOf(PropTypes.shape({
        crsActionPlanTipID: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        orderNumber: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        header: PropTypes.string,
        paragraph: PropTypes.string,
        onOffRule: PropTypes.string,
        onOffDefault: PropTypes.bool
    })).isRequired,
    setSelectedTipId: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    deleteOnClick: PropTypes.func.isRequired,
    editOnClick: PropTypes.func.isRequired,
    createOnClick: PropTypes.func.isRequired,
    createDisabled: PropTypes.bool
};

export default ActionPlanTipTable;
